import { useQuery } from '@tanstack/react-query';
import DOMPurify from 'dompurify';
import { DEFAULT_IMPRINT_HTML, type PublicLegalResponse } from '@bm/contracts';
import { api } from '../lib/api';
import { LegalPageLayout } from '../components/LegalPageLayout';

/** Impressum — Inhalt kommt vollständig aus `platformSettings.legal.imprintHtml`,
 * vom Plattformadmin frei bearbeitbar (Plattform › Impressum & Datenschutz,
 * `PlatformLegalPage.tsx`). Öffentlicher, ungeschützter Endpunkt
 * (`GET /public/legal`) — DOMPurify sanitisiert das gespeicherte HTML vor
 * dem Rendern, auch wenn nur ein Plattformadmin es schreiben kann (Defense
 * in Depth: dieses HTML läuft im Browser jedes anonymen Besuchers). Siehe
 * docs/legal.md.
 */
export function ImprintPage() {
  const { data, isLoading } = useQuery({
    queryKey: ['public', 'legal'],
    queryFn: () => api<PublicLegalResponse>('/public/legal'),
  });

  const html = DOMPurify.sanitize(data?.imprintHtml ?? DEFAULT_IMPRINT_HTML);

  return (
    <LegalPageLayout title="Impressum">
      {isLoading ? (
        <p className="text-sm text-slate-400">Lädt…</p>
      ) : (
        <div className="legal-content" dangerouslySetInnerHTML={{ __html: html }} />
      )}
    </LegalPageLayout>
  );
}
